<div *ngIf="!initialPageLoad">
  <div *ngIf="!hideInternalUserFlow">
    <div class="page">
      <div class="title">
        <h3 class="page-title">Enter a policy number</h3>
      </div>
    </div>
    <div class="upsc-custom-internal-dashboard">
      <div class="main">
        <form [formGroup]="policyForm">
          <div class="mb-3">
            <span class="heading">{{ 'adjuster.policy.heading' | translate }}</span>
          </div>
          <div class="field-row">
            <div class="field-label">
              <span class="labelstyle">{{'adjuster.policy.number' | translate}}</span><br>
              <span class="labelSubText">{{'adjuster.policy.version' | translate}}</span>
            </div>
            <div>
              <mat-form-field class="form-spacing">
                <input matInput upscTrim formControlName='policy' placeholder="{{'common.policy' | translate}}"
                  maxLength='25'>
                <mat-error *ngIf="policyForm.controls['policy'].hasError('required')">
                  {{'userProfile.payee.errors.required' | translate}}
                </mat-error>
                <mat-error *ngIf="policyForm.controls['policy'].hasError('pattern')">
                  {{'userProfile.payee.errors.required' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="systemError" class="error-message">
            {{ 'common.systemError' | translate }}
          </div>
          <div *ngIf="notFound" class="error-message">
            No Policy Found.
          </div>
          <div class="error-message policy" *ngIf="invalidError">
            {{ 'common.invalidError' | translate }}
          </div>
          <div class="d-flex justify-content-end mt-sm-3">
            <button class="upsc-primary-button" *ngIf="!submitting" (click)="continue()">Continue</button>
            <button class="upsc-primary-button icon-right" *ngIf="submitting" disabled>Continue <span
                class="spinner-border"></span></button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="smb" *ngIf="showSMBButton">
    <button class="upsc-primary-button icon-right" (click)="navigateToSMB()">SMB Portal
      <mat-icon>chevron_right</mat-icon></button>
  </div>
<!--   <upsc-collapsible-panel-light *ngIf="showVerificationCode" [title]="'adjuster.email.title' | translate"
    [isCollapsed]="isCollapsed">
    <div class="upsc-custom-internal-dashboard">
      <div class="main">
        <form [formGroup]="emailForm">
          <div class="mb-3">
            <span class="heading">{{ 'adjuster.email.heading' | translate }}</span>
          </div>
          <div class="field-row">
            <div class="field-label">
              <span class="labelstyle">{{'adjuster.email.emailId' | translate}}</span>
            </div>
            <div>
              <mat-form-field class="form-spacing">
                <input matInput upscTrim formControlName='emailId'>
                <mat-error *ngIf="emailForm.controls['emailId'].hasError('required')">
                  {{'userProfile.payee.errors.required' | translate}}
                </mat-error>
                <mat-error *ngIf="emailForm.controls['emailId'].hasError('pattern')">
                  {{'userProfile.payee.errors.email' | translate}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="systemError_Code" class="error-message">
            {{ 'common.systemError' | translate }}
          </div>
          <div *ngIf="notFound_Code" class="error-message">
            No Email Address Found.
          </div>
          <div *ngIf="codExpired" class="error-message">
            Verification Code Expired, Please try again.
          </div>
          <div class="d-flex justify-content-end mt-sm-3">
            <button class="upsc-primary-button" *ngIf="!submitting_Code" (click)="getVerificationCode()">Get
              Code</button>
            <button class="upsc-primary-button icon-right" *ngIf="submitting_Code" disabled>Get Code <span
                class="spinner-border"></span></button>
          </div>
        </form>
      </div>
    </div>
  </upsc-collapsible-panel-light> -->

<!--   <upsc-collapsible-panel-light *ngIf="showResult" [isCollapsed]="isCollapsed2">
    <div class="upsc-custom-internal-dashboard">
      <div class="mb-3">
        <span class="heading">{{ 'adjuster.email.title' | translate }}</span>
      </div>
      <div class="main">
        <div class="mb-3">
          <span class="heading">{{ 'adjuster.email.result' | translate }}</span>
        </div>
        <div class="field-row">
          <div class="field-label">
            <span class="labelstyle">{{'adjuster.email.verificationCode' | translate}}</span> &nbsp;
            <span class="boldText">{{getVerificationCodeData.verificationCode }}</span> <br />
            <span class="labelstyle">{{'adjuster.email.emailAddress' | translate}}</span> &nbsp;
            <span class="boldText">{{ getVerificationCodeData.email }} </span><br />
            <span class="labelstyle">{{'adjuster.email.dateTime' | translate}}</span> &nbsp;
            <span class="boldText">{{getVerificationCodeData.createdTimestamp | date:'yyyy-MM-dd HH:mm:ss'}} </span>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-sm-3">
          <button class="upsc-primary-button" (click)="getNewCode()">Get a New Code</button>
        </div>
      </div>
    </div>
  </upsc-collapsible-panel-light> -->

  <upsc-collapsible-panel-light [title]="'adjuster.IS4UPS.title' | translate" *ngIf="is4upsIndicator">
    <div class="wrapper-full profile-wrapper">
      <!-- show IS4UPS box -->
      <div>
        <div class="page">
          <div class="title">
            <h3 class="page-title">Enter a policy number</h3>
          </div>
        </div>
        <div class="upsc-custom-internal-dashboard">
          <div class="main">
            <form [formGroup]="policyForm1">
              <div class="mb-3">
                <span class="heading">{{ 'adjuster.policy.heading' | translate }}</span>
              </div>
              <div class="field-row">
                <div class="field-label">
                  <span class="labelstyle">{{'adjuster.policy.number' | translate}}</span><br>
                  <span class="labelSubText">{{'adjuster.policy.version' | translate}}</span>
                </div>
                <div>
                  <mat-form-field class="form-spacing">
                    <input matInput upscTrim formControlName='policy1' placeholder="{{'common.policy' | translate}}"
                      maxLength='25'>
                    <mat-error *ngIf="policyForm1.controls['policy1'].hasError('required')">
                      {{'userProfile.payee.errors.required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="policyForm1.controls['policy1'].hasError('pattern')">
                      {{'userProfile.payee.errors.required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="my-buttons">
                  <div *ngIf="!validButNoData">
                    <button class="upsc-primary-button" *ngIf="!submitting1" (click)="getIS4UPSDetails()">Get IS4UPS
                      Details</button>
                    <button class="upsc-primary-button icon-right" *ngIf="submitting1" disabled>Get IS4UPS Details <span
                        class="spinner-border"></span></button>
                  </div>
                  <div *ngIf="validButNoData">
                    <button class="upsc-primary-button" *ngIf="!submitting1" (click)="addData()">Add new IS4UPS
                      Details</button>
                  </div>
                </div>
              </div>

              <div class="warning" *ngIf="validButNoData">
                <span class="text">
                  This policy is not included on a current campaign. If you would like to include this policy, please
                  click on "add new IS4UPS Details" again.
                </span>
              </div>
              <div class="warning" *ngIf="traditionalCargo">
                <span class="text">
                  It appears this policy has already been converted or is an existing Transaction Cargo policy.
                </span>
              </div>

              <div *ngIf="systemError1" class="error-message">
                {{ 'common.systemError' | translate }}
              </div>
              <div *ngIf="notFound1" class="error-message">
                No Policy Found.
              </div>

            </form>
          </div>
        </div>
      </div>
      <div class="wrapper-box" *ngIf="showIS4UPSResult">
        <div class="policy-information">
          <div class="main">
            <form [formGroup]="IS4UPSForm">
              <div class="d-flex flex-column">
                <div class="row">
                  <div class="col-6">
                    <mat-form-field>
                      <mat-label>{{ 'adjuster.IS4UPS.policyNumber' | translate }}</mat-label>
                      <input matInput upscTrim formControlName="policyNumber" maxLength='25'
                        placeholder="{{'common.policy' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['policyNumber'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['policyNumber'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.emailAddress' | translate }}</mat-label>
                      <input matInput upscTrim formControlName='emailAddress'
                        placeholder="{{'adjuster.IS4UPS.emailAddress2' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['emailAddress'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['emailAddress'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="row">
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.currentMinLimit' | translate }}</mat-label>
                      <input matInput upscTrim formControlName='currentMinLimit' type="number" min="0"
                        placeholder="{{'adjuster.IS4UPS.currentMinLimit2' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['currentMinLimit'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['currentMinLimit'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.newMinLimit' | translate }}</mat-label>
                      <input matInput upscTrim formControlName='newMinLimit' type="number" min="0"
                        placeholder="{{'adjuster.IS4UPS.newMinLimit2' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['newMinLimit'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['newMinLimit'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="row">
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{'adjuster.IS4UPS.currentMaxLimit' | translate}}</mat-label>
                      <input matInput upscTrim formControlName='currentMaxLimit' type="number" min="0"
                        placeholder="{{'adjuster.IS4UPS.currentMaxLimit2' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['currentMaxLimit'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['currentMaxLimit'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.newMaxLimit' | translate }}</mat-label>
                      <input matInput upscTrim formControlName='newMaxLimit' type="number" min="0"
                        placeholder="{{'adjuster.IS4UPS.newMaxLimit2' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['newMaxLimit'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['newMaxLimit'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column">
                <div class="row">
                  <div class="col-6">
                    <mat-form-field>
                      <mat-label>{{ 'adjuster.IS4UPS.currentRate' | translate }}</mat-label>
                      <input matInput upscTrim formControlName="currentRate" max="999.99" type="number" min="0" placeholder="{{'adjuster.IS4UPS.currentRate' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['currentRate'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['currentRate'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.newRate' | translate }}</mat-label>
                      <input matInput upscTrim formControlName='newRate' type="number" min="0" max="999.99"
                        placeholder="{{'adjuster.IS4UPS.newRate' | translate}}">
                      <mat-error *ngIf="IS4UPSForm.controls['newRate'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                      <mat-error *ngIf="IS4UPSForm.controls['newRate'].hasError('pattern')">
                        {{'userProfile.payee.errors.email' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column">
                <!-- createdDateTime -->
                <div class="row">
                  <div class="col-6">
                    <mat-form-field class="form-spacing">
                      <mat-label>{{ 'adjuster.IS4UPS.createDateTime' | translate }}</mat-label>
                      <input matInput [matDatepicker]="picker" formControlName="createdDateTime"
                        placeholder="{{'adjuster.IS4UPS.createDateTime2' | translate}}">
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <svg matDatepickerToggleIcon id="baseline-date_range-24px" xmlns="http://www.w3.org/2000/svg"
                          width="31.711" height="31.711" viewBox="0 0 31.711 31.711">
                          <path id="Path_219" data-name="Path 219"
                            d="M10.928,13.892H8.285v2.643h2.643Zm5.285,0H13.57v2.643h2.643Zm5.285,0H18.855v2.643H21.5Zm2.643-9.249H22.819V2H20.177V4.643H9.606V2H6.964V4.643H5.643A2.631,2.631,0,0,0,3.013,7.285L3,25.783a2.642,2.642,0,0,0,2.643,2.643h18.5a2.65,2.65,0,0,0,2.643-2.643V7.285A2.65,2.65,0,0,0,24.141,4.643Zm0,21.141H5.643V11.249h18.5Z"
                            transform="translate(0.964 0.643)" fill="#737373" />
                          <path id="Path_220" data-name="Path 220" d="M0,0H31.711V31.711H0Z" fill="none" />
                        </svg>
                      </mat-datepicker-toggle>
                      <mat-datepicker [touchUi]="isMobile" #picker></mat-datepicker>
                      <mat-error *ngIf="IS4UPSForm.controls['createdDateTime'].hasError('required')">
                        {{'userProfile.payee.errors.required' | translate}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div *ngIf="submitError" class="error-message">
                {{ 'common.systemError' | translate }}
              </div>
              <div class="d-flex justify-content-end mt-sm-3">
                <button class="upsc-primary-button" *ngIf="!loading" (click)="submitIS4UPSDetails()">Update</button>
                <button class="upsc-primary-button icon-right" *ngIf="loading" disabled>Update <span
                    class="spinner-border"></span></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </upsc-collapsible-panel-light>


  <upsc-collapsible-panel-light [isCollapsed]="isCampaingnCollapsed" [title]="'adjuster.IS4UPS2.title' | translate"
    *ngIf="is4upsIndicator">
    <div class="main">
      <div class="document-upload panel-section">
        <div class="file-error" *ngFor="let error of errorList">
          The file {{error.filename}} could not be uploaded due to: {{error.error}}.
        </div>
        <div class="file-error" *ngIf="removeDocumentError">
          System error occurred while trying to remove the document. Please try again.
        </div>
        <div class="section-wrapper">
          <div class="document-panel-right mr-sm-1 mr-lg-2">
            <div class="title-is4ups">
              <span class="text">Upload MCMP Excel File >
                <span class="download-template" (click)="downloadTemplate()">Download MCMP Template</span>
              </span>
            </div>
            <div class="uploaded-documents d-flex justify-content-center align-items-center"
              [ngStyle]="{'border-color': '#707070'}" (click)="CampaignFile.click()" upscDragNDrop
              (onFileDropped)="uploadDocument($event, 'IS4UPS-Campaign-Files')" multiple>
              <input hidden type="file" #CampaignFile
                (change)="uploadDocument($event.target.files, 'IS4UPS-Campaign-Files', $event)">
              <div class="d-flex flex-column justify-content-center align-items-center">
                <img class="pb-2" src="../../../../../assets/images/upload-file-icon.png">
                <div class="attachments-title pb-2">
                  {{'claimsDetail.upload.message1.1' | translate }}
                  <span class="upload-underline">{{ 'claimsDetail.upload.message2.1' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="uploaded-attachments">
              <ul class="your-attachments">
                <li class="d-inline-flex justify-content-start align-items-center" *ngFor="let file of campaignFiles">
                  <div>{{file.file.name}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </upsc-collapsible-panel-light>
</div>

<div *ngIf="initialPageLoad" class="page-loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
